import { Button } from "@/components/ui/button";
import { CalendarHeart, ArrowRight } from "lucide-react";
import { SITE } from "@/config/site";

export default function ResultsCallout() {
  const c = SITE.resultsCallout;

  return (
    <div
      className="mt-8 rounded-2xl border border-primary/20 bg-gradient-to-br from-teal-50 via-white to-amber-50 p-6 sm:p-8 shadow-sm"
      data-testid="results-coaching-callout"
    >
      <div className="flex flex-col sm:flex-row gap-6 items-start sm:items-center">
        <div className="h-12 w-12 shrink-0 rounded-2xl bg-primary/10 grid place-items-center">
          <CalendarHeart className="h-6 w-6 text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="font-heading text-lg sm:text-xl font-semibold text-slate-900">
            {c.title}
          </h3>
          <p className="mt-2 text-slate-600 leading-relaxed text-sm sm:text-base">
            {c.body}
          </p>
        </div>
        <a
          href={c.ctaLink}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full sm:w-auto"
          data-testid="results-coaching-cta"
        >
          <Button
            className="rounded-full px-5 py-5 text-sm sm:text-base bg-primary hover:bg-teal-900 w-full sm:w-auto whitespace-normal h-auto leading-snug"
          >
            {c.ctaLabel}
            <ArrowRight className="ml-1.5 h-4 w-4 shrink-0" />
          </Button>
        </a>
      </div>
    </div>
  );
}
